interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

const sizeConfig = {
  sm: { container: 'w-20 h-20', img: 'w-9' },
  md: { container: 'w-28 h-28', img: 'w-12' },
  lg: { container: 'w-36 h-36', img: 'w-16' },
};

export default function Loader({ size = 'md', fullScreen = true }: LoaderProps) {
  const { container, img } = sizeConfig[size];

  const spinner = (
    <div className={`relative ${container}`}>
      <svg className="absolute inset-0 w-full h-full animate-spin" viewBox="0 0 100 100" style={{ animationDuration: '1.4s' }}>
        <circle cx="50" cy="50" r="44" fill="none" stroke="#e5e7eb" strokeWidth="3" />
        <circle cx="50" cy="50" r="44" fill="none" stroke="#FF0000" strokeWidth="3" strokeLinecap="round" strokeDasharray="69 207" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <img src="/LogoImages/amber_loader_icon.jpg" alt="FRAETERNITY" className={`${img} h-auto`} />
      </div>
    </div>
  );

  if (!fullScreen) return spinner;

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      {spinner}
    </div>
  );
}
